import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import * as actions from '../../actions/index';
import AdminNavigation from '../Inc/AdminNavigation';
import SearchAlumni from '../Inc/SearchAlumni';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class QuickSearch extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...props,
    }
  }

  render() {
    return (
      <div>
        <LayoutHeader />
        <AdminNavigation />
        <div className='quick-search-widget'>
          <SearchAlumni />
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(QuickSearch);





// WEBPACK FOOTER //
// ./src/components/QuickSearch/AdminSearch.js